// https://medium.com/angular-in-depth/retry-failed-http-requests-in-angular-f5959d486294

import { Observable, of, throwError } from 'rxjs'
import { delay, mergeMap, retryWhen } from 'rxjs/operators'

import { isDevMode } from '@angular/core'
// import { ToastService as toast } from '../_services/toast.service'

const getErrorMessage = (maxRetry: number) =>
  `Tried to load Resource over XHR for ${maxRetry} times without success :(`

const DEFAULT_BACKOFF_DELAY = 20 // ms
const DEFAULT_MAX_RETRIES = 3
const DEFAULT_BACKOFF = 300 // ms

export function retryWithBackoff( delayMs = DEFAULT_BACKOFF_DELAY,
                                  maxRetry = DEFAULT_MAX_RETRIES,
                                  backoffMs = DEFAULT_BACKOFF ) {

  let retries = maxRetry
  // let idm = isDevMode()

  return (src: Observable<any>) =>
    src.pipe(
      retryWhen((errors: Observable<any>) => errors.pipe(
        mergeMap(error => {
          return throwError(error)
          
          if (isDevMode()) {
            // console.log('bypassing retry (isDevMode)')
            return throwError(error)
          }
          if (retries-- > 0) {
            const backoffTime = delayMs + (maxRetry - retries) * backoffMs
            console.log(`retrying (${(maxRetry - retries)}/${maxRetry})`)
            return of(error).pipe(delay(backoffTime))
          }
          // toast.error("Something went wrong, and we've been notified. \
          //   Please try again after refreshing the page.", "Oops...")

          // return throwError(getErrorMessage(maxRetry))
          return throwError(error)
        })
      )))
}
